module.exports = __webpack_public_path__ + "static/media/BE-EXTC_FYP.f2d5b0e4.pdf";